module.exports = __webpack_public_path__ + "static/media/GT18_GT_Payment-Types.9050c7b1.csv";